import agriculture from "src/pages/Welcome/images/designYourContent/industryBG/argiculture.png";
import noneIndustry from "src/pages/Welcome/images/designYourContent/industryBG/default.jpeg";
import education from "src/pages/Welcome/images/designYourContent/industryBG/education.png";
import energy from "src/pages/Welcome/images/designYourContent/industryBG/energy.png";
import events from "src/pages/Welcome/images/designYourContent/industryBG/events.jpg";
import finance from "src/pages/Welcome/images/designYourContent/industryBG/finance.jpg";
import fitness from "src/pages/Welcome/images/designYourContent/industryBG/fitness.png";
import healthcare from "src/pages/Welcome/images/designYourContent/industryBG/healthcare.jpg";
import hospitality from "src/pages/Welcome/images/designYourContent/industryBG/hospitality-food-beverages.jpg";
import manufacturing from "src/pages/Welcome/images/designYourContent/industryBG/manufacturing.jpg";
import media from "src/pages/Welcome/images/designYourContent/industryBG/media-advertising.jpg";
import other from "src/pages/Welcome/images/designYourContent/industryBG/other.png";
import placeOfWorship from "src/pages/Welcome/images/designYourContent/industryBG/place-of-worship.jpg";
import realEstate from "src/pages/Welcome/images/designYourContent/industryBG/real-estate.png";
import retail from "src/pages/Welcome/images/designYourContent/industryBG/retail.jpg";
import software from "src/pages/Welcome/images/designYourContent/industryBG/software-service.jpg";
import telecomunication from "src/pages/Welcome/images/designYourContent/industryBG/telecomunication.jpg";
import transportation from "src/pages/Welcome/images/designYourContent/industryBG/transportation.jpg";
import { Industries } from "src/constants/constants";
import { placeholderTemplateByIndustry } from "./constants";
import { capitalizeEachWord } from "src/utils";
import {
  Maybe,
  OnboardingCommonAppInstanceTemplatesQuery,
  Org,
} from "src/types.g";

export const getPlaceholderTemplateByIndustry = ({
  templateName,
  industry,
}: {
  templateName: string;
  industry: string;
}) => {
  if (!industry || !templateName) return "";
  return placeholderTemplateByIndustry[industry][templateName];
};

export const isTemplateAvailableForIndustry = ({
  templateName,
  industry,
}: {
  templateName: string;
  industry?: string;
}) => {
  if (!industry) return false;

  const industryTemplates =
    placeholderTemplateByIndustry[industry as Industries];

  // Convert both strings to lowercase and remove all whitespace characters
  // This ensures matches like:
  // "Emergency Alert" === "EmergencyAlert"
  // "emergency  alert" === "Emergency Alert"
  // "EMERGENCY ALERT" === "emergency alert"
  return Object.keys(industryTemplates || {}).some(
    (key) =>
      key.toLowerCase().replace(/\s+/g, "") ===
      templateName.toLowerCase().replace(/\s+/g, ""),
  );
};

export const getDefaultTemplates = (
  commonAppInstanceTemplates: OnboardingCommonAppInstanceTemplatesQuery["allCommonAppInstanceTemplates"],
) => {
  if (
    !commonAppInstanceTemplates ||
    !commonAppInstanceTemplates.nodes ||
    commonAppInstanceTemplates.nodes.length === 0
  )
    return [];

  const fallbackTemplates = placeholderTemplateByIndustry[Industries.Other];
  return commonAppInstanceTemplates?.nodes?.filter((template) =>
    Object.keys(fallbackTemplates).includes(template?.name || ""),
  );
};

export const trimTemplateName = (templateName: string) => {
  if (!templateName) return "";
  const trimmed = templateName.includes(" - ")
    ? templateName.split(" - ")[1]
    : templateName;

  return capitalizeEachWord(trimmed);
};

export const getIndustryBg = (industry: string) => {
  switch (industry) {
    case Industries.Agriculture:
      return agriculture;
    case Industries.Education:
      return education;
    case Industries.Events:
      return events;
    case Industries.Finance:
      return finance;
    case Industries.Fitness:
      return fitness;
    case Industries.Healthcare:
      return healthcare;
    case Industries.HospitalityFoodBeverage:
      return hospitality;
    case Industries.Manufacturing:
      return manufacturing;
    case Industries.MediaAndAdvertising:
      return media;
    case Industries.PlacesOfWorship:
      return placeOfWorship;
    case Industries.RealEstate:
      return realEstate;
    case Industries.Retail:
      return retail;
    case Industries.SoftwareAndService:
      return software;
    case Industries.Telecommunication:
      return telecomunication;
    case Industries.Energy:
      return energy;
    case Industries.Other:
      return other;
    case Industries.Transportation:
      return transportation;
    default:
      return noneIndustry;
  }
};

export const getIndustry = (currentOrg: Maybe<Org>) => {
  if (!currentOrg) return Industries.Other;
  const validIndustries = Object.keys(placeholderTemplateByIndustry);
  const industry = currentOrg?.preferences?.settings?.industry_name;
  if (!industry || !validIndustries.includes(industry)) return Industries.Other;
  return industry;
};

export const getAvailableTemplates = ({
  commonAppInstanceTemplates,
  industry,
}: {
  commonAppInstanceTemplates: OnboardingCommonAppInstanceTemplatesQuery["allCommonAppInstanceTemplates"];
  industry: string;
}) => {
  if (!commonAppInstanceTemplates || !commonAppInstanceTemplates.nodes)
    return [];
  let filteredTemplates = commonAppInstanceTemplates?.nodes?.filter(
    (template) =>
      isTemplateAvailableForIndustry({
        templateName: template?.name || "",
        industry,
      }),
  );

  if (filteredTemplates?.length === 0) {
    // fallback to default templates from Other industry
    filteredTemplates = getDefaultTemplates(commonAppInstanceTemplates);
  }

  return filteredTemplates;
};
